import { useNextRouterContext } from "@faire/deprecated-retailer-visitor-shared/app/_lib/routing/NextRouterContext";
import { ILeanBrandTileRendererBaseProps } from "@faire/deprecated-retailer-visitor-shared/components/LeanBrandTileRenderer/__internal__/LeanBrandTileRendererBase";
import { LeanBrandTileRendererForCarouselBase } from "@faire/deprecated-retailer-visitor-shared/components/LeanBrandTileRenderer/__internal__/LeanBrandTileRendererForCarouselBase";
import { ILeanBrandTileWithReview } from "@faire/deprecated-retailer-visitor-shared/components/LeanBrandTileRenderer/ILeanBrandTileWithReview";
import { SignUpElement } from "@faire/deprecated-retailer-visitor-shared/lib/popSignUp";
import { brandPage } from "@faire/deprecated-retailer-visitor-shared/paths/index";
import { useSettingBrandLinkHoverThreshold } from "@faire/deprecated-retailer-visitor-shared/settings/getSettingBrandLinkHoverTheshold";
import { getSettingRscLibp } from "@faire/deprecated-retailer-visitor-shared/settings/getSettingRscLibp";
import { Column } from "@faire/web/slate/Layout";
import { SpacerValueOrKey } from "@faire/web/slate/spacing/getSpacing";
import { PrefetchKind } from "next/dist/client/components/router-reducer/router-reducer-types";
import * as React from "react";

interface ILeanBrandTileRendererForCarouselProps
  extends Pick<ILeanBrandTileRendererBaseProps, "brandPageQueryParams"> {
  /**
   * Intentional, when undefined, we render the loading tile
   */
  leanBrandTile?: ILeanBrandTileWithReview;
  onClick?: (token: string) => void;
  bottomPadding?: SpacerValueOrKey;
  showMinimum?: boolean;
  signUpSourceId?: string;
  signUpElement?: SignUpElement; // For unique cases not being used in a carousel
  customButton?: React.ReactElement;
}

export const LeanBrandTileRendererForCarousel: React.FC<
  ILeanBrandTileRendererForCarouselProps
> = ({
  onClick,
  leanBrandTile,
  brandPageQueryParams,
  bottomPadding,
  showMinimum,
  signUpSourceId,
  signUpElement,
  customButton,
}) => {
  const token = leanBrandTile?.brand?.token;
  const PREFETCH_DELAY_MS = useSettingBrandLinkHoverThreshold();
  const timeoutRef = React.useRef<ReturnType<typeof setTimeout> | undefined>(
    undefined
  );
  const { prefetch: nextPrefetch } = useNextRouterContext();
  const isRSCBrandPage = getSettingRscLibp();

  const handleClick = () => {
    clearTimeout(timeoutRef.current);
    if (onClick && token) {
      onClick(token);
    }
  };
  const handleFocus = () => {
    timeoutRef.current = setTimeout(() => {
      if (isRSCBrandPage) {
        if (token) {
          nextPrefetch(brandPage(token), {
            kind: PrefetchKind.FULL,
          });
        }
      }
    }, PREFETCH_DELAY_MS);
  };
  const handleBlur = () => {
    clearTimeout(timeoutRef.current);
  };

  return (
    <Column
      style={{ height: "100%" }}
      data-test-id={`lean-brand-tile-renderer-onclick-container-${token}`}
      onClick={handleClick}
      onMouseEnter={handleFocus}
      onMouseLeave={handleBlur}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onTouchStart={handleFocus}
    >
      <LeanBrandTileRendererForCarouselBase
        brandTile={leanBrandTile}
        brandPageQueryParams={brandPageQueryParams}
        bottomPadding={bottomPadding}
        showMinimum={showMinimum}
        signUpTracking={{
          element: signUpElement ?? SignUpElement.CAROUSEL,
          sourceId: `${signUpSourceId}`,
        }}
        customButton={customButton}
      />
    </Column>
  );
};
